import styled from "@emotion/styled";
import { Button } from "@9amhealth/shared";
import { BiometricVerificationBloc } from "src/hybrid/components/BiometricVerification";
import { useBloc } from "src/state/state";
import type { TextForAuthTypes } from "../GlobalOverlays/Overlays/BiometricSetup";
import { textForAuthTypes } from "../GlobalOverlays/Overlays/BiometricSetup";
import LockIcon from "src/ui/assets/icons/LockIcon";
import Data from "../Data/Data";
import translate from "src/lib/translate";

const Wrap = styled.div`
  padding: 1rem 1rem 1.5rem;
`;

const BiometricAuthenticationSetup = () => {
  const [
    {
      biometricType,
      isBiometricVerificationEnabled,
      isBiometricVerificationAvailable
    },
    { enableBiometric, disableBiometric }
  ] = useBloc(BiometricVerificationBloc);

  const text: TextForAuthTypes =
    textForAuthTypes[biometricType] ??
    ({
      name: "biometric",
      icon: <LockIcon />,
      title: "signInQuicker",
      description: "biometric.description",
      button: "enable_signIn"
    } satisfies TextForAuthTypes);

  if (!isBiometricVerificationAvailable) {
    return null;
  }

  return (
    <Data.Table title={translate(text.name)}>
      <Wrap>
        {isBiometricVerificationEnabled ? (
          <>
            <p>{translate(text.description)}</p>
            <Button
              theme="charcoal"
              outline
              size="small"
              hideArrow
              onPress={(): void => void disableBiometric()}
            >
              {translate("disable.feature", {
                context: "biometricAuth",
                feature: translate(text.name)
              })}
            </Button>
          </>
        ) : (
          <>
            <p>{translate(text.description)}</p>
            <Button
              theme="charcoal"
              outline
              size="small"
              hideArrow
              onPress={(): void => void enableBiometric()}
            >
              {translate("enable.feature", {
                context: "biometricAuth",
                feature: translate(text.name)
              })}
            </Button>
          </>
        )}
      </Wrap>
    </Data.Table>
  );
};

export default BiometricAuthenticationSetup;
